// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyState_wrapper__Bnckx"};